import { LineChartValue, UDFApiResponseWithData } from '@cex/shared-modules';
import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

const tradingviewAdapter = createEntityAdapter<any>({});
const initialState = tradingviewAdapter.getInitialState();

import { RootState } from '@/app/store';
import { mainEmptySplitApi } from '@/features/main/mainApi';

export const tradingviewApi = mainEmptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTradingview: builder.query({
      query: ({ ticker, symbol, resolution, from, to }) =>
        `/${ticker}/tradingview/history?symbol=${symbol}&resolution=${resolution}&from=${from}&to=${to}`,
      transformResponse: async (responseData: UDFApiResponseWithData, meta, { ticker }) => {
        try {
          const { t: timestamp, c: close } = responseData;

          // Format for the lineChart needs to be like: https://tradingview.github.io/lightweight-charts/docs/api/interfaces/LineData
          const transformedData = {
            id: ticker,
            chartData: timestamp?.map<LineChartValue>((time, index) => ({
              time,
              value: Number(close[index])
            })),
            tvData: responseData
          };

          return tradingviewAdapter.upsertOne(initialState, transformedData);
        } catch (e) {
          // TODO: add toast for showing the user an error
          console.error('Error on tradingview data', e);
        }
      }
    })
  })
});

// Selectors
// Calling `someEndpoint.select(someArg)` generates a new selector that will return
// the query result object for a query with those parameters.
// To generate a selector for a specific query argument, call `select(theQueryArg)`.
// In this case, the users query has no params, so we don't pass anything to select()
export const selectTradingviewResult =
  // @ts-ignore
  tradingviewApi.endpoints.getTradingview.select();

const selectTradingviewData = createSelector(selectTradingviewResult, (apiSlice) => apiSlice.data);

export const { selectAll: selectAllTradingview } = tradingviewAdapter.getSelectors(
  (state: RootState) => selectTradingviewData(state) ?? initialState
);

export const { useGetTradingviewQuery } = tradingviewApi;
